import { prop } from 'models/lib/create_model';
import { createContentModel } from './composition_content_shared';

export default createContentModel({
  modelName: 'CreditCardCompositionContent',

  properties: {
    amount: prop(Number).default(null),
    memo: prop(String).default(''),
  },

  isEmpty() {
    return !this.amount;
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/composition/credit_card_composition_content.js